import React from 'react';
import {
  AutoComplete,
  AutoCompleteProps as PrimeAutoCompleteProps,
} from 'primereact/autocomplete';

type AutoCompleteInputProps<T> = Omit<
  PrimeAutoCompleteProps,
  'value' | 'suggestions'
> & {
  value?: T | T[];
  suggestions?: T[];
  className?: string;
  onBlur?: () => void;
};

export const AutoCompleteInput = <T,>({
  value,
  suggestions = [],
  placeholder = 'Rechercher...',
  className = '',
  disabled = false,
  forceSelection = true,
  field,
  multiple = false,
  onChange,
  completeMethod,
  onSelect,
  onUnselect,
  itemTemplate,
  selectedItemTemplate,
  emptyMessage = 'Aucun résultat trouvé',
  dropdown = false,
  minLength = 1,
  delay = 300,
  style,
  onBlur,
}: AutoCompleteInputProps<T>) => {
  const handleBlur = (e: React.FocusEvent<HTMLDivElement>) => {
    // Vérifier si le focus ne va pas à un élément enfant
    if (!e.currentTarget.contains(e.relatedTarget as Node)) {
      onBlur?.();
    }
  };

  return (
    <div className={`w-full ${className}`} onBlur={handleBlur}>
      <AutoComplete
        appendTo="self"
        unstyled
        value={value}
        suggestions={suggestions}
        completeMethod={completeMethod}
        onChange={onChange}
        onSelect={onSelect}
        onUnselect={onUnselect}
        placeholder={placeholder}
        disabled={disabled}
        forceSelection={forceSelection}
        field={field}
        multiple={multiple}
        itemTemplate={
          itemTemplate ??
          ((item) => (
            <div className="px-4 py-2 bg-almostBlack !border-none hover:bg-gray-700 text-white cursor-pointer w-full overflow-hidden text-ellipsis whitespace-nowrap">
              <span
                className="block truncate"
                title={typeof item === 'string' ? item : String(item)}
              >
                {item}
              </span>
            </div>
          ))
        }
        selectedItemTemplate={selectedItemTemplate}
        emptyMessage={emptyMessage}
        dropdown={dropdown}
        minLength={minLength}
        delay={delay}
        style={style}
        className="w-full"
        inputClassName="w-full h-[48px] px-4 !bg-almostBlack text-white placeholder-baseDarkGrey text-[13.8px] font-raleway border-none rounded-md focus:outline-none transition-all"
        panelClassName="bg-red-700 border border-gray-600 mt-2 rounded-md shadow-lg z-50 max-w-full overflow-hidden"
      />
    </div>
  );
};
